

















































































































































































































































































































































































































































































































































import { appModule } from "@/store/modules/app";
import { storePerawat } from "@/store/modules/perawat";
import { userModule } from "@/store/modules/user";
import { Component, Vue, Prop, Watch, Ref } from "vue-property-decorator";
import AsesmenPerawatService from "@/services/AsesmenKeperawatanGadarService";
import AsesmenKeperawatanGadarStore from "@/store/modules/AsesmenKeperawatanGadarStore";
import moment from "moment";
// import AsesmenAwalIgd from "@/services/AsesmenAwalIgd";
import FrekuensiNadi from "@/components/pemeriksaan/assesmen/FrekuensiNadi.vue";
import FrekuensiNafas from "@/components/pemeriksaan/assesmen/FrekuensiNafas.vue";
import SaturasiOksigen from "@/components/pemeriksaan/assesmen/SaturasiOksigen.vue";
import SuhuBadan from "@/components/pemeriksaan/assesmen/SuhuBadan.vue";
import TekananDarah from "@/components/pemeriksaan/assesmen/TekananDarahNew.vue";
import SkalaNyeri from "@/components/pemeriksaan/assesmen/SkalaNyeri.vue";
import Lokasi from "@/components/pemeriksaan/assesmen/Lokasi.vue";
import Durasi from "@/components/pemeriksaan/assesmen/Durasi.vue";
import Frekuensi from "@/components/pemeriksaan/assesmen/Frekuensi.vue";
import Pencetus from "@/components/pemeriksaan/assesmen/Pencetus.vue";
import KualitasNyeri from "@/components/pemeriksaan/assesmen/KualitasNyeri.vue";
import PolaSerangan from "@/components/pemeriksaan/assesmen/PolaSerangan.vue";
import PenyebabNyeriHilang from "@/components/pemeriksaan/assesmen/PenyebabNyeriHilang.vue";
import JenisNyeri from "@/components/pemeriksaan/assesmen/JenisNyeri.vue";
import InputNyeri from "@/components/nyeri/InputNyeri.vue";
import AsesmenNyeri from "@/components/AsesmenAwalGadar/AsesmenNyeri.vue";
import { storePasien } from "@/store/modules/pasien";
import { isEmpty } from "lodash";
import { Nyeri } from "@/types/asesmen";
import {
  kbStatusOptions,
  kbJenisOptions
} from "@/constants/kebidananOptions";

@Component({
  components: {
    TekananDarah,
    FrekuensiNadi,
    FrekuensiNafas,
    SuhuBadan,
    SaturasiOksigen,
    SkalaNyeri,
    Lokasi,
    Durasi,
    Frekuensi,
    Pencetus,
    KualitasNyeri,
    PolaSerangan,
    PenyebabNyeriHilang,
    JenisNyeri,
    InputNyeri,
    AsesmenNyeri
  }
})
export default class AsesmenKeperawatanIgdPage extends Vue {
  @Prop() readonly register!: number;
  @Prop() readonly rm!: number;
  @Ref() readonly refRiwayatAlergi;

  get canSave(): boolean {
    return (
      userModule.canAccessForm("asesmen_awal_gadar", "create") ||
      userModule.canAccessForm("asesmen_awal_gadar", "edit")
    );
  }

  mounted() {
    this.getData();
  }

  @Watch("isAnyAlergi")
  changeIsAnyAlergi(val) {
    if (val) {
      this.refRiwayatAlergi.focus();
    }
  }

  rules = {
    requiredAllergy: (value: string) => {
      const cond = value.length === 0 && this.isAnyAlergi;

      return (
        !(isEmpty(value) && this.isAnyAlergi) ||
        "Alergi harus disebutkan bila pasien mempunyai alergi!"
      );
    }
  };

  saving = false;
  showHphtPicker = false;
  showHplPicker = false;
  maxHphtDate = new Date().toISOString().substr(0, 10);
  timePickerProps = { format: "24hr", scrollable: true };
  datePickerProps = { locale: "id" };

  id = null;

  isAnyAlergi = false;
  arivedAt = new Date();
  triage = null;
  arival = null;
  transportasi = null;
  transportasiDescription = null;
  kasus = null;
  arivalDescription = null;
  kasusDescription = null;

  riwayatAlergi = null;
  riwayatObat = null;
  riwayatPenyakitLalu = null;
  riwayatMakanTerakhir = null;
  riwayatLainLain = null;
  obsRiwayat = null;
  obsStatusPerkawinan = null;
  obsG = null;
  obsP = null;
  obsA = null;
  obsAH = null;
  obsUsiaHamil = null;
  obsHpht = null;
  obsHpl = null;
  obsPalpasiLeo = null;
  obsTfu = null;
  obsTbj = null;
  obsHis = null;
  obsDjj = null;
  obsPanggul = null;
  obsVt = null;
  obsLla = null;
  obsTb = null;
  obsBb = null;
  obsKb = null;
  obsKbDescription = null;
  obsKbJenis: string | null = null;

  tvTensi = {
    sistole: "0",
    diastole: "0"
  };
  tvNadi = null;
  tvNafas = null;
  tvSuhu = null;
  tvSaturasiO2 = null;
  gcsEye = null;
  gcsVerbal = null;
  gcsMotor = null;
  asesRisjat = null;
  asesKecemasan = null;

  nyeriSkala = 0;
  nyeriLokasi = null;
  nyeriFrekuensi = null;
  nyeriDurasi = null;
  nyeriPencetus = null;
  nyeriKualitas = null;
  nyeriPolaSerangan = null;
  nyeriPenyebabHilang = null;
  nyeriJenis = null;

  perawat = null;

  arivalOptions = [
    { id: 1, name: "Datang Sendiri" },
    { id: 2, name: "Diantar" },
    { id: 3, name: "Rujukan" },
    { id: 99, name: "Lainnya" }
  ];
  transportasiOptions = [
    { id: 1, name: "Ambulance" },
    { id: 0, name: "Non Ambulance" }
  ];
  kasusOptions = [
    { id: 0, name: "Non-Trauma" },
    { id: 1, name: "Trauma" },
    { id: 2, name: "Obsgyn" },
    { id: 3, name: "Anak" },
    { id: 99, name: "Lainnya" }
  ];
  triageOptions = [
    { id: 1, name: "Kategori 1", color: "#B71C1C" },
    { id: 2, name: "Kategori 2", color: "#EF5350" },
    { id: 3, name: "Kategori 3", color: "yellow" },
    { id: 4, name: "Kategori 4", color: "#1B5E20" },
    { id: 5, name: "Kategori 5", color: "#66BB6A" }
  ];
  kbOptions = kbStatusOptions;
  kbJenisOptions = kbJenisOptions;

  get isUsingKb() {
    const id = (this.obsKb as any)?.id;
    return typeof id === "number" && id > 0;
  }

  gcsEyeOptions = [
    { id: 1, name: "Tidak membuka mata" },
    { id: 2, name: "Dengan rangsangan nyeri" },
    { id: 3, name: "Dengan perintah suara" },
    { id: 4, name: "Spontan" },
    { id: 0, name: "NT" }
  ];
  gcsVerbalOptions = [
    { id: 1, name: "Tidak bersuara" },
    { id: 2, name: "Mengerang" },
    { id: 3, name: "Kata" },
    { id: 4, name: "Orientasi abnormal" },
    { id: 5, name: "Kalimat lengkap dan orientasi baik" },
    { id: 0, name: "NT" }
  ];
  gcsMotorOptions = [
    { id: 1, name: "Tidak bergerak" },
    { id: 2, name: "Response ekstensi abnormal" },
    { id: 3, name: "Response fleksi abnormal" },
    { id: 4, name: "Menjauhi nyeri" },
    { id: 5, name: "Melokalisir nyeri" },
    { id: 6, name: "Sesuai perintah" },
    { id: 0, name: "NT" }
  ];
  levelKesadaran = [
    { maxVal: 15, text: "Composmentis" },
    { maxVal: 13, text: "Apatis" },
    { maxVal: 11, text: "Delirium" },
    { maxVal: 9, text: "Somnolen" },
    { maxVal: 6, text: "Sopor" },
    { maxVal: 4, text: "Semi Coma" },
    { maxVal: 3, text: "Coma" }
  ];
  asesRisjatOptions = [
    { id: 0, name: "Tidak Berisiko" },
    { id: 1, name: "Risiko Sedang" },
    { id: 2, name: "Risiko Tinggi" }
  ];
  asesKecemasanOptions = [
    { id: 0, name: "Tidak" },
    { id: 1, name: "Ringan" },
    { id: 2, name: "Sedang" },
    { id: 3, name: "Berat" }
  ];

  get usiaKehamilanText() {
    const hpht = this.obsHpht ? new Date(this.obsHpht) : new Date();
    const diff = new Date().getTime() - hpht.getTime();

    const age = Math.floor(diff / (1000 * 60 * 60 * 24));

    this.obsUsiaHamil = age;

    const day = age % 7,
      week = (age - day) / 7;

    const dayText = day ? `${day} Hari` : "",
      weekText = week ? `${week} Minggu` : "";

    return [weekText, dayText].join(" ") ?? "-";
  }

  get arivalDescriptionLabel() {
    if (this.arival.id == 2) {
      return "Diantar oleh";
    }

    if (this.arival.id == 3) {
      return "Rujukan dari";
    }

    if (this.arival.id == 99) {
      return "Sebutkan kedatangan lainnya";
    }

    return "Sebutkan";
  }

  get gcsEyeOpts() {
    return this.gcsEyeOptions.sort((a, b) => b.id - a.id);
  }

  get gcsVerbalOpts() {
    return this.gcsVerbalOptions.sort((a, b) => b.id - a.id);
  }

  get gcsMotorOpts() {
    return this.gcsMotorOptions.sort((a, b) => b.id - a.id);
  }

  get kesadaranDescription() {
    const gcs = this.gcsEye + this.gcsVerbal + this.gcsMotor;

    const val = this.levelKesadaran
      .sort((a, b) => a.maxVal - b.maxVal)
      .find(item => gcs <= item.maxVal);

    return val && this.gcsEye && this.gcsVerbal && this.gcsMotor
      ? val.text
      : "-";
  }

  get input() {
    return {
      pasien_rm: this.rm,
      register_id: this.register,
      content: {
        kedatangan: {
          arivedAt: this.formatedArivedAt,
          triage: this.triage,
          arival: this.arival,
          arivalDescription: this.arivalDescription,
          transportasi: this.transportasi,
          transportasiDescription: this.transportasiDescription,
          kasus: this.kasus,
          kasusDescription: this.kasusDescription
        },
        riwayatKesehatan: {
          alergi: this.riwayatAlergi,
          obat: this.riwayatObat,
          penyakitLalu: this.riwayatPenyakitLalu,
          makanTerakhir: this.riwayatMakanTerakhir,
          lain: this.riwayatLainLain
        },
        riwayatObstetri: {
          riwayat: this.obsRiwayat,
          status_perkawinan: this.obsStatusPerkawinan,
          g: this.obsG,
          p: this.obsP,
          a: this.obsA,
          ah: this.obsAH,
          hpht: this.obsHpht,
          hpl: this.obsHpl,
          usiaHamil: this.obsUsiaHamil,
          palpasi: this.obsPalpasiLeo,
          tfu: this.obsTfu,
          tbj: this.obsTbj,
          his: this.obsHis,
          djj: this.obsDjj,
          panggul: this.obsPanggul,
          vt: this.obsVt,
          lla: this.obsLla,
          tb: this.obsTb,
          bb: this.obsBb,
          kb: this.obsKb,
          kbDescription: this.obsKbDescription,
          kbJenis: this.obsKbJenis
        },
        tanda_vital: {
          tensi: this.tvTensi,
          nadi: this.tvNadi,
          nafas: this.tvNafas,
          suhu: this.tvSuhu,
          saturasi: this.tvSaturasiO2
        },
        gcs: {
          eye: this.gcsEye,
          verbal: this.gcsVerbal,
          motor: this.gcsMotor
        },
        risiko_jatuh: this.asesRisjat,
        kecemasan: this.asesKecemasan,
        nyeri: this.nyeri,
        perawat: this.perawat
      },
      version: "1"
    };
  }

  get nyeri() {
    return {
      skala: this.nyeriSkala,
      lokasi: this.nyeriLokasi,
      frekuensi: this.nyeriFrekuensi,
      durasi: this.nyeriDurasi,
      pencetus: this.nyeriPencetus,
      kualitas: this.nyeriKualitas,
      pola_serangan: this.nyeriPolaSerangan,
      penyebab_hilang: this.nyeriPenyebabHilang,
      jenis: this.nyeriJenis
    };
  }

  get listPerawat() {
    return storePerawat.listPerawat;
  }

  get triageColor() {
    const val = this.triageOptions.find(item => {
      return this.triage && this.triage.id == item.id;
    });

    console.log(val);

    return val ? val.color : null;
  }

  get storeAsesmenPerawat() {
    return AsesmenKeperawatanGadarStore;
  }

  get formatedArivedAt() {
    return moment(this.arivedAt).format("YYYY-MM-DD HH:mm:ss");
  }

  get pasienAlergi() {
    return storePasien.identitasPasien?.alergi;
  }

  setNyeriVal(val: Nyeri) {
    this.nyeriSkala = val.skala;
    this.nyeriLokasi = val.lokasi;
    this.nyeriFrekuensi = val.frekuensi;
    this.nyeriDurasi = val.durasi;
    this.nyeriPencetus = val.pencetus;
    this.nyeriKualitas = val.kualitas;
    this.nyeriPolaSerangan = val.pola_serangan;
    this.nyeriPenyebabHilang = val.penyebab_hilang;
    this.nyeriJenis = val.jenis;
  }

  setTensi(val) {
    console.log("val tensi", val);
    this.tvTensi = val;
  }

  setFrekNadi(val) {
    this.tvNadi = val;
  }

  setFrekNafas(val) {
    this.tvNafas = val;
  }

  setSuhu(val) {
    this.tvSuhu = val;
  }

  setSaturasiO2(val) {
    this.tvSaturasiO2 = val;
  }

  // setSkalaNyeri(val) {
  //   console.log("set skala nyeri", val);
  //   this.nyeriSkala = val;
  // }

  save() {
    if (!this.saving) {
      this.saving = true;

      const sendRequest = this.id
        ? AsesmenPerawatService.update(this.id, this.input)
        : AsesmenPerawatService.create(this.input);

      sendRequest
        .then(() => {
          // set store module

          appModule.NoticeDelay("Berhasil Simpan Asesmen Keperawatan");

          this.getData();
        })
        .finally(() => {
          this.saving = false;

          storePasien.getDataPasien(this.rm);
        });
    }
  }

  remove() {
    const q = confirm("Hapus Asesmen Keperawatan?");

    if (q) {
      this.deleteData();
    }
  }

  async deleteData() {
    const del = await AsesmenPerawatService.destroy(this.id);

    if (del.data) {
      appModule.NoticeDelay("Berhasil Hapus Asesmen Keperawatan");

      await this.getData();
      this.clearInput();
    }
  }

  async getData() {
    await AsesmenKeperawatanGadarStore.getByRegister(this.register).then(() => {
      const data = this.storeAsesmenPerawat.asesmen,
        content = data?.content;

      if (content) {
        this.id = data?.id;

        this.triage = content?.kedatangan.triage;
        this.arivedAt = new Date(content?.kedatangan.arivedAt);
        this.arival = content?.kedatangan.arival;
        this.transportasi = content?.kedatangan.transportasi;
        this.arivalDescription = content?.kedatangan.arivalDescription;
        this.kasus = content?.kedatangan.kasus;
        this.kasusDescription = content?.kedatangan.kasusDescription;

        this.riwayatAlergi = content?.riwayatKesehatan.alergi;
        this.riwayatObat = content?.riwayatKesehatan.obat;
        this.riwayatPenyakitLalu = content?.riwayatKesehatan.penyakitLalu;
        this.riwayatMakanTerakhir = content?.riwayatKesehatan.makanTerakhir;
        this.riwayatLainLain = content?.riwayatKesehatan.lain;
        this.obsRiwayat = content?.riwayatObstetri.riwayat;
        this.obsStatusPerkawinan = content?.riwayatObstetri.status_perkawinan;
        this.obsG = content?.riwayatObstetri.g;
        this.obsP = content?.riwayatObstetri.p;
        this.obsA = content?.riwayatObstetri.a;
        this.obsHpht = content?.riwayatObstetri.hpht;
        this.obsHpl = content?.riwayatObstetri.hpl;
        this.obsAH = content?.riwayatObstetri.ah;
        this.obsUsiaHamil = content?.riwayatObstetri.usiaHamil;
        this.obsPalpasiLeo = content?.riwayatObstetri.palpasi;
        this.obsTfu = content?.riwayatObstetri.tfu;
        this.obsTbj = content?.riwayatObstetri.tbj;
        this.obsHis = content?.riwayatObstetri.his;
        this.obsDjj = content?.riwayatObstetri.djj;
        this.obsPanggul = content?.riwayatObstetri.panggul;
        this.obsVt = content?.riwayatObstetri.vt;
        this.obsLla = content?.riwayatObstetri.lla;
        this.obsTb = content?.riwayatObstetri.tb;
        this.obsBb = content?.riwayatObstetri.bb;
        this.obsKb = content?.riwayatObstetri.kb;
        this.obsKbDescription = content?.riwayatObstetri.kbDescription;
        this.obsKbJenis = content?.riwayatObstetri.kbJenis ?? null;

        this.tvTensi = content?.tanda_vital.tensi ?? null;
        this.tvNadi = content?.tanda_vital?.nadi ?? null;
        this.tvNafas = content?.tanda_vital?.nafas ?? null;
        this.tvSuhu = content?.tanda_vital?.suhu ?? null;
        this.tvSaturasiO2 = content?.tanda_vital?.saturasi ?? null;
        this.gcsEye = content?.gcs?.eye ?? null;
        this.gcsVerbal = content?.gcs?.verbal ?? null;
        this.gcsMotor = content?.gcs?.motor ?? null;
        this.asesRisjat = content?.risiko_jatuh ?? null;
        this.asesKecemasan = content?.kecemasan ?? null;
        this.nyeriSkala = content?.nyeri?.skala ? content.nyeri.skala : 0;
        this.nyeriLokasi = content?.nyeri?.lokasi ? content.nyeri.lokasi : 0;
        this.nyeriFrekuensi = content?.nyeri?.frekuensi
          ? content.nyeri.frekuensi
          : null;
        this.nyeriDurasi = content?.nyeri?.durasi ? content.nyeri.durasi : null;
        this.nyeriPencetus = content?.nyeri?.pencetus
          ? content.nyeri.pencetus
          : null;
        this.nyeriKualitas = content?.nyeri?.kualitas
          ? content.nyeri.kualitas
          : null;
        this.nyeriPolaSerangan = content?.nyeri?.pola_serangan
          ? content.nyeri.pola_serangan
          : null;
        this.nyeriPenyebabHilang = content?.nyeri?.penyebab_hilang
          ? content.nyeri.penyebab_hilang
          : null;
        this.nyeriJenis = content?.nyeri?.jenis ? content.nyeri.jenis : null;

        this.perawat = content?.perawat;
      }
    });

    if (!this.id && !this.riwayatAlergi && this.pasienAlergi) {
      this.isAnyAlergi = true;
      this.riwayatAlergi = this.pasienAlergi;
    }

    this.isAnyAlergi = !isEmpty(this.riwayatAlergi) ? true : false;
  }

  dummyData() {
    this.triage = this.triageOptions.find(({ id }) => id === 3);
    this.arival = this.arivalOptions.find(({ id }) => id === 2);
    this.transportasi = this.transportasiOptions.find(({ id }) => id === 0);
    this.arivalDescription = "dengan orang lain";
    this.kasus = this.kasusOptions.find(({ id }) => id === 99);
    this.kasusDescription = "kasus luar biasa";

    // this.riwayatAlergi = "makanan laut";
    this.riwayatObat = "paracetamol 1x3 siang habis makan";
    this.riwayatPenyakitLalu = "hipertensi";
    this.riwayatMakanTerakhir = "tadi siang";
    this.riwayatLainLain = "penyakit lainnya";
    this.obsRiwayat = "hamil ektopik";
    this.obsG = 5;
    this.obsP = 4;
    this.obsA = 1;
    this.obsAH = 3;
    this.obsHpht = "2021-06-01";
    this.obsHpl = "2022-03-10";
    this.obsPalpasiLeo = "palpasi leo";
    this.obsTfu = 30;
    this.obsTbj = 12;
    this.obsHis = 12;
    this.obsDjj = 13;
    this.obsPanggul = 15;
    this.obsVt = 20;
    this.obsLla = 10;
    this.obsTb = 160;
    this.obsBb = 60;
    this.obsKb = this.kbOptions.find(({ id }) => id === 1);
    this.obsKbDescription = "susuk";

    this.tvTensi = {
      sistole: "110",
      diastole: "80"
    };
    this.tvNadi = 36;
    this.tvNafas = 36;
    this.tvSuhu = 36;
    this.tvSaturasiO2 = 90;
    this.gcsEye = 1;
    this.gcsVerbal = 1;
    this.gcsMotor = 1;
    this.asesRisjat = 0;
    this.asesKecemasan = 0;

    this.nyeriSkala = 2;
    this.nyeriLokasi = null;
    this.nyeriFrekuensi = null;
    this.nyeriDurasi = null;
    this.nyeriPencetus = null;
    this.nyeriKualitas = null;
    this.nyeriPolaSerangan = null;
    this.nyeriPenyebabHilang = null;
    this.nyeriJenis = null;

    this.perawat = this.listPerawat.find(({ id }) => id === 490);
  }

  clearInput() {
    this.id = null;

    this.arivedAt = new Date();
    this.triage = null;
    this.arival = null;
    this.transportasi = null;
    this.kasus = null;
    this.arivalDescription = null;
    this.kasusDescription = null;

    this.riwayatAlergi = null;
    this.riwayatObat = null;
    this.riwayatPenyakitLalu = null;
    this.riwayatMakanTerakhir = null;
    this.riwayatLainLain = null;
    this.obsRiwayat = null;
    this.obsStatusPerkawinan = null;
    this.obsG = null;
    this.obsP = null;
    this.obsA = null;
    this.obsAH = null;
    this.obsUsiaHamil = null;
    this.obsHpht = null;
    this.obsHpl = null;
    this.obsPalpasiLeo = null;
    this.obsTfu = null;
    this.obsTbj = null;
    this.obsHis = null;
    this.obsDjj = null;
    this.obsPanggul = null;
    this.obsVt = null;
    this.obsLla = null;
    this.obsTb = null;
    this.obsBb = null;
    this.obsKb = null;
    this.obsKbDescription = null;
    this.obsKbJenis = null;

    this.tvTensi = {
      sistole: "0",
      diastole: "0"
    };
    this.tvNadi = null;
    this.tvNafas = null;
    this.tvSuhu = null;
    this.tvSaturasiO2 = null;
    this.gcsEye = null;
    this.gcsVerbal = null;
    this.gcsMotor = null;
    this.asesRisjat = null;
    this.asesKecemasan = null;

    this.nyeriSkala = 0;
    this.nyeriLokasi = null;
    this.nyeriFrekuensi = null;
    this.nyeriDurasi = null;
    this.nyeriPencetus = null;
    this.nyeriKualitas = null;
    this.nyeriPolaSerangan = null;
    this.nyeriPenyebabHilang = null;
    this.nyeriJenis = null;

    this.perawat = null;
  }

  @Watch("arivedAt")
  changeArivedAt(val) {
    console.log("arived at", val);
    console.log("this arived at", this.arivedAt);
  }

  printAsesmenAwal() {
    // AsesmenAwalIgd.printByRegister(this.register);
  }
}
